<template>
    <header
        :class="{
            'hero': true,
            'hero--split-layout': featureFlag('hero-split-layout'),
            'hero--vertical': featureFlag('hero-vertical')
        }"
    >
        <transition name="fade">
            <template v-if="featureFlag('hero-lottie') && (lottieLoading || lottieIllustration)">
                <BaseLottieIllustration
                    :lottie-illustration="lottieIllustration || ''"
                    :loading="lottieLoading"
                />
            </template>
            <template v-else-if="image?.largest">
                <img
                    :src="image.largest"
                    :srcset="getSrcSet(image, 'header')"
                    sizes="100vw"
                    :alt="image.alt || ''"
                    class="hero__background"
                >
            </template>
            <template v-else-if="placeholder">
                <content-placeholders-img class="hero__background" />
            </template>
        </transition>

        <div
            v-if="$slots.text || placeholder"
            class="hero__text"
        >
            <slot name="text">
                <content-placeholders-text
                    v-if="placeholder"
                    :lines="2"
                />
            </slot>
        </div>

        <div
            v-if="$slots.banner"
            class="hero__banner"
        >
            <slot name="banner" />
        </div>
    </header>
    <div
        v-if="!!$slots.after"
        class="hero-after"
    >
        <slot name="after" />
    </div>
</template>

<script setup>
import useSrcSets from '~/utils/srcset';

const { featureFlag } = useMultisite();
const { getSrcSet } = useSrcSets();

const props = defineProps({
    placeholder: {
        type: Boolean,
        required: false,
        default: false
    },
    lottieIllustration: {
        type: String,
        required: false,
        default: ''
    },
    lottieLoading: {
        type: Boolean,
        required: false,
        default: false
    },
    image: {
        type: Object,
        required: false,
        default: null
    }
});

if (import.meta.dev) {
    watchEffect(() => {
        // eslint-disable-next-line no-console
        console.info('[lottie:hero] boundary', JSON.stringify({
            enabled: featureFlag('hero-lottie'),
            loading: props.lottieLoading,
            valueType: typeof props.lottieIllustration,
            bytes: props.lottieIllustration.length,
        }));
    });
}
</script>
<style lang="less" src="./BaseHero.less" />
